import axios from '../../axios';
import {
   ADD_USER,
   GET_USER,
   GET_USER_BY_ID,
   USER_PROFILE,
   UPDATE_USER_HISTORY,
   UPDATE_USER,
   DELETE_USER,
   IS_ERROR,
   GET_USERS,
   RESET_USER_PASSWORD,
   SEND_OTP,
   RESET_PASSWORD,
   USER_GLOBAL_SETTINGS,
   SEND_OTP_IN_EMAIL_OR_MOBILE,
} from '../types';
import { toast } from 'react-toastify';

export const getUser = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/user/all');

      if (res.data.code === 1) {
         if (res.data.data) {
            dispatch({ type: GET_USER, payload: res.data.data });
            return res.data.data;
         } else {
            toast.error('No data returned from the API');
         }
      } else if (res.data.code === 2) {
         toast.warn(res.data.message);
      } else {
         toast.error('Unknown error occurred');
      }
      return null;
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         toast.error(err.response.data.message);
      } else {
         toast.error('An unknown error occurred');
      }
      return null;
   }
};

export const getUsers = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/user/all', { params });
      if (res.data.code === 1) {
         if (res.data) {
            dispatch({ type: GET_USERS, payload: res.data });
         }
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }

      return res.data;
   } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
         toast.error(error.response.data.message);
      }
      return error.response;
   }
};

export const updateUserRights = (data) => async (dispatch) => {
   try {
      const response = await axios.post(`/user/update/userRights`, data);

      if (response.data.code === 1) {
         toast.success('User rights updated successfully');
         return response.data.userRights;
      } else {
         toast.error('No user rights returned from the API');
         return [];
      }
   } catch (error) {
      // Handle specific errors and network issues
      if (error.response) {
         const { status, data } = error.response;

         if (status === 404) {
            toast.error('User not found');
         } else if (status === 400) {
            toast.error(data.message || 'Bad Request');
         } else {
            toast.error(data.message || 'An unknown error occurred');
         }
      } else {
         toast.error('A network error occurred');
      }
      return null; // Return null to ensure the calling function knows it failed
   }
};

export const updateUserStatus = (id, status) => async (dispatch) => {
   try {
      const response = await axios.post('/user/update/status', {
         id: id,
         status: status,
      });

      if (response.data.code === 1) {
         toast.success('User status updated successfully');
         dispatch({
            type: 'UPDATE_USER_STATUS',
            payload: {
               id: id,
               status: status,
            },
         });
         return true;
      } else {
         toast.error('Failed to update user status');
         return false;
      }
   } catch (error) {
      if (error.response) {
         const { status, data } = error.response;
         if (status === 404) {
            toast.error('User not found');
         } else if (status === 400) {
            toast.error(data.message || 'Bad Request');
         } else {
            toast.error(data.message || 'An unknown error occurred');
         }
      } else {
         toast.error('A network error occurred');
      }
      return false;
   }
};

export const updateUserFinancialYear = (financialYear) => async (dispatch) => {
   try {
      const response = await axios.post('/user/update/financialYear', {
         financialYear: financialYear,
      });

      if (response.data.code === 1) {
         toast.success('User Financial Year updated successfully');
         return response.data;
      } else {
         toast.error('Failed to update user status');
         return response.data;
      }
   } catch (error) {
      if (error.response) {
         const { status, data } = error.response;
         if (status === 404) {
            toast.error('User not found');
         } else if (status === 400) {
            toast.error(data.message || 'Bad Request');
         } else {
            toast.error(data.message || 'An unknown error occurred');
         }
      } else {
         toast.error('A network error occurred');
      }
      return false;
   }
};

export const resetUserPassword = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/user/resetPassword`, formData);

      if (res.data.code === 1) {
         dispatch({ type: RESET_USER_PASSWORD, payload: res.data.data });

         setTimeout(() => {
            toast.success('Password updated successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log("error", err);
      if (err.response.status === 400 || err.response.status === 500) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.code === 2) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const sendOtp = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/user/send-otp', formData, {
         headers: {
            Authorization: 'Bearer essential',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: SEND_OTP, payload: res.data.data });

         setTimeout(() => {
            toast.success('OTP Send successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const sendOtpInEmailOrNo = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/user/sendOtpInEmailOrMobile', formData, {
         headers: {
            Authorization: 'Bearer essential',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: SEND_OTP_IN_EMAIL_OR_MOBILE, payload: res.data.data });

         setTimeout(() => {
            toast.success('OTP Send successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const forgetPassword = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/user/forgetPassword', formData, {
         headers: {
            Authorization: 'Bearer essential',
         },
      });

      if (res.data.code === 1) {
         dispatch({ type: RESET_PASSWORD, payload: res.data.data });

         setTimeout(() => {
            toast.success('New Password Set successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400 || err.response.status === 500) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getUserById = (userId) => async (dispatch) => {
   try {
      const res = await axios.get(`/user/${userId}`);

      if (res.data.code === 1) {
         if (res.data.data) {
            dispatch({ type: GET_USER_BY_ID, payload: res.data.data });
         } else {
            toast.error('No data returned from the API');
         }
      } else if (res.data.code === 2) {
         toast.warn(res.data.message);
      } else {
         toast.error('Unknown error occurred');
      }
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         toast.error(err.response.data.message);
      } else {
         toast.error('An unknown error occurred');
      }
   }
};

export const addUser = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/user/add', data);
      if (res.data.code === 1) {
         dispatch({ type: ADD_USER, payload: res.data.data });
         dispatch({ type: IS_ERROR, payload: false });
         localStorage.setItem('userId', res.data.data.id);
         toast.success('User added successfully');
         return res.data;
      } else if (res.data.code === 2) {
         dispatch({ type: IS_ERROR, payload: true });
         toast.warn(res.data.message);
         return res.data;
      } else {
         dispatch({ type: IS_ERROR, payload: true });
         toast.error('Unknown error occurred');
         return res.data;
      }
   } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
         dispatch({ type: IS_ERROR, payload: true });
         toast.error(err.response.data.message);
         return err.response.data;
      } else {
         dispatch({ type: IS_ERROR, payload: true });
         toast.error('An unknown error occurred');
         return err.response.data;
      }
   }
};

export const updateUser = (payload) => async (dispatch) => {
   try {
      const res = await axios.post(`/user/update`, payload);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_USER, payload: res.data.data });

         setTimeout(() => {
            toast.success('User  updated successfully!');
         }, 1000);
         return res.data;
      } else {
         toast.error('Failed to update user. Please try again.');
         return res.data;
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data.message);
         return err.response.data;
      }
      if (
         err.response &&
         err.response.data &&
         err.response.data.errors &&
         err.response.data.errors[0] &&
         err.response.data.errors[0].message
      ) {
         toast.error(err.response.data.errors[0].message);
         return err.response.data;
      } else {
         toast.error('Failed to update user. Please try again.');
         return err.response.data;
      }
   }
};

export const userProfile = () => async (dispatch) => {
   try {
      const res = await axios.get('/user/profile');
      if (res.data.code === 1) {
         dispatch({ type: USER_PROFILE, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const userGlobalSettings = () => async (dispatch) => {
   try {
      const res = await axios.get('/settings/all');
      if (res.data.code === 1) {
         dispatch({ type: USER_GLOBAL_SETTINGS, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deleteUser = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/user/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_USER, payload: { id } });
         setTimeout(() => {
            toast.success('User deleted successfully!');
         }, 1000);
      }

      if (res.data.code === 2) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log("delete err", err);
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Vehicle. Please try again.");
   }
};
export const updateUserHistory = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/user/update/history', data);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_USER_HISTORY, payload: res.data.data });
         // toast.success('User history updated successfully');
      } else if (res.data.code === 2) {
         toast.warn(res.data.message);
      } else {
         toast.error('Unknown error occurred');
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
